import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions } from 'actionsets'
import StyleSheet from 'styles'
import {eventKeyMatches, humanize, KEYS} from 'utils'
import { CenteredCard } from 'components'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import qs from 'qs'

export class Reset extends Component{

  constructor(props){
    super(props)
    TokenActions.bindActions(this)
  }

  setPasswordConfirmation = ({target: { value: passwordConfirmation}}) => {
    this.setState({passwordConfirmation})
  }

  setPassword = ({target: { value: password}}) => {
    this.setState({password})
  }

  get token(){
    return qs.parse(window.location.search.substr(1)).token
  }

  submit = async () => {
    await this.actions.reset({...this.state, token: this.token})
    try {
      await this.actions.verify()
    }
    finally {
      this.props.history.push('/')
    }
  }

  renderError = () =>
    <Typography variant='body2' className={styles.error}>
      {this.props.error.title}
    </Typography>

  renderErrorMessages = () => Object.entries(this.props.error.meta || {}).map(([key, value]) =>
    <Typography  key={key} variant='body1' className={styles.error}>
      <span>{`${humanize(key)}: ${[...new Set(value)]}`}</span>
    </Typography>
  )

  render = () =>
    <CenteredCard className={styles.card}>
      <CardContent onKeyUp={(e) => eventKeyMatches(e, KEYS.enter) && this.submit()}>
        <Typography variant='h6'>Reset your password</Typography>
        <Typography variant='body2'>To continue</Typography>
        {this.props.error && <p className={styles.error}>{this.renderError()}</p>}
        {this.props.error && this.renderErrorMessages()}
        <TextField
          autoFocus={window.innerWidth > 500}
          label='Enter your password'
          type='password'
          onChange={this.setPassword}
          ref={this.focusPasswordInput}
          fullWidth
          margin="normal"
        />
        <TextField
          label='Enter your password again'
          type='password'
          onChange={this.setPasswordConfirmation}
          fullWidth
          margin="normal"
        />
      </CardContent>
      <CardActions className={styles.actions}>
        <Button fullWidth className={styles.button} variant='contained' color="primary" onClick={this.submit}>Submit</Button>
      </CardActions>
    </CenteredCard>
}

const styles = StyleSheet({
  error: {
    color: '#EA5142'
  },
  button:{
    margin: 0
  },
  card: {
    padding: 15,
    paddingBottom: 20
  },
  actions: {
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    flexDirection: 'column',
    paddingLeft: 16,
    paddingRight: 16
  }
})

export default connect(({tokens}) => tokens)(Reset)